import mainServer from '@/api/index'

const state = {
    products: [],
    customerInfo: [],
    companyInfo: null,
    salesInfo: {},
    customerServiceInfo: {},
    allCountry: [],
    timeZones: []
};

const mutations = {

    setProducts(state, data) {
        state.products = data;
    },
    setCountrys(state, data) {
        state.allCountry = data;
    },
    setCustomerInfo(state, data) {
        state.customerInfo = data;
    },
    setCompanyInfo(state, data) {
        state.companyInfo = data;
    },
    setSalesInfo(state, data) {
        state.salesInfo = data;
    },
    setCustomerServiceInfo(state, data) {
        state.customerServiceInfo = data;
    },
    setTimeZones(state, data) {
        state.timeZones = data;
    },
};

const actions = {

    loadProducts({
        commit,
        state
    }, status) {
        if (state.companyInfo.orgId) {
            mainServer.queryProducts({}).then((res) => {
                commit('setProducts', res.data)
            });
        }

    },
    loadTimeZones({
        commit,
        state
    }, status) {

        mainServer.queryTimeZones().then((res) => {
            commit('setTimeZones', res.data)
        });


    },
    loadCountrys({
        commit,
        state
    }, status) {

        mainServer.queryCountry({}).then((res) => {
            let countrys = res.data.map(item => item.code)

            commit('setCountrys', countrys)
        });


    },
    loadCustomerInfo({
        commit,
        state
    }, status) {
        return new Promise((resolve, reject) => {
            mainServer.queryCustomerInfo({ customerId: BigInt(JSON.parse(localStorage.getItem('user')).orgId) }).then((res) => {
                commit('setCustomerInfo', res.data)
                resolve(res)
            });
        })

    },
    loadCompanyInfo({
        commit,
        state
    }, status) {
        return new Promise((resolve, reject) => {
            mainServer.queryCompanyInfo().then((res) => {
                commit('setCompanyInfo', res.data)
                resolve(res)
            });
        })

    },
    loadSalesInfo({
        commit,
        state
    }, status) {
        return new Promise((resolve, reject) => {
            if (state.companyInfo.saleId) {
                mainServer.queryUserInfo({ userId: BigInt(state.companyInfo.saleId) }).then((res) => {
                    commit('setSalesInfo', res.data)
                    resolve(res)
                });
            }

        })

    },
    loadCustomerServiceInfo({
        commit,
        state
    }, status) {
        return new Promise((resolve, reject) => {
            if (state.companyInfo.customerServiceId) {
                mainServer.queryUserInfo({ userId: BigInt(state.companyInfo.customerServiceId) }).then((res) => {
                    commit('setCustomerServiceInfo', res.data)
                    resolve(res)
                });
            }

        })

    },

};

export default {
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/customer.js